import React, { Component } from "react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import $ from "jquery";
import { tokenVerification } from "./Utils";

class PatientJournal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      journalData: [],
      pageNum: null,
      paginationValue: 5,
      isLoading: true,
    };
  }

  componentDidMount() {
    var thisController = this;
    setTimeout(() => {
      thisController.fetchJournals();
    }, 300);
  }

  fetchJournals() {
    var thisController = this;
    let patientProcedureId = localStorage.getItem("patientProcedureId");
    $.ajax({
      url: "/my-jeeva-api/fetch-treatment-journal",
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        procedureId: patientProcedureId,
      },
      success: function (res) {
        if (res.success == true) {
          var resp = res.result;
          thisController.state.journalData = resp;
          localStorage.setItem("patient_journals", JSON.stringify(res.result));
          thisController.state.isLoading = false;
          thisController.setState(thisController.state);
        }
      }, error: function (xhr, status, error) {
        var errorMessage = xhr.status + ': ' + xhr.statusText
        if (xhr.status == 401) {
          tokenVerification();
        }
      }
    });
  }

  onPageChange = (e) => {
    this.setState({ pageNum: e });
  };

  CustomNoDataComponent = () => (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <p>There are no journals present. </p>
    </div>
  );

  caseInsensitiveSort = (field) => (rowA, rowB) => {
    const a = rowA[field] ? rowA[field].toLowerCase() : '';
    const b = rowB[field] ? rowB[field].toLowerCase() : '';

    if (a > b) {
      return 1;
    }

    if (b > a) {
      return -1;
    }

    return 0;
  };


  getColumns() {
    const columns = [
      {
        name: <b style={{ fontSize: "16px" }}>Name</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('title'),
        selector: (row) => (
          <div
            className="textarea"
            style={{
              background: "white",
              height: "2.7em",
              resize: "none",
              paddingLeft: "0px",
              paddingTop: "6px",
              width: "100%",
              border: "none",
              borderRadius: "2px",
              textAlign: "start",
            }}
          >
            {row.title}
          </div>
        ),
      },

      {
        name: (
          <div>
            <b style={{ fontSize: "16px" }}>Action</b>
          </div>
        ),
        cell: (row) => (
          <div
            style={{
              background: "white",
              height: "2.7em",
              resize: "none",
              paddingLeft: "13px",
              paddingTop: "6px",
              width: "100%",
              textAlign: "start",
            }}
          >
            <Link
              to="/projectmgmt/patient-admission/manage-admission/view-patient-journal-result"
              onClick={() => {
                this.setJournalIdToLocal(row.id, row.title);
              }}
            >
              <button
                style={{
                  backgroundColor: "#282a65",
                  border: "none",
                  color: "white",
                  borderRadius: "5px",
                  padding: "5px",
                }}
              >
                View Results
              </button>
            </Link>
          </div>
        ),
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      },
    ];
    return columns;
  }
  // customStyles() {
  //   const customStyles = {
  //     headCells: {
  //       style: {
  //         padding: "10px",
  //       },
  //     },

  //     cells: {
  //       style: {
  //         border: " 1px solid black",
  //         padding: "15px",
  //       },
  //     },
  //     rows: {
  //       style: {},
  //     },
  //   };
  //   return customStyles;
  // }

  setJournalIdToLocal(id, title) {
    localStorage.setItem("journalId", id);
    localStorage.setItem("journalTitle", title);
  }

  render() {
    return (
      <div className="main-journal" style={{ margin: "auto", height: "60vh" }}>
        <h6
          className="nav-item"
          style={{
            color: "#282a65",
            marginTop: "15px",
            marginLeft: "-51vw",
            fontSize: "18px",
          }}
        >
          Journal
        </h6>
        <br />
        <div style={{ boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)" }}>
          {this.state.isLoading && (
            <div style={{ padding: '20px', textAlign: 'center' }}>
              <p>Loading ...</p>
            </div>
          )}
          {!this.state.isLoading && this.state.journalData.length === 0 && (
            <div style={{ padding: '20px', textAlign: 'center' }}>
              <p>There are no journal records to display  </p>
            </div>
          )}
          {this.state.journalData.length > 0 && (
            <DataTable
              columns={this.getColumns()}
              data={this.state.journalData}
              // customStyles={this.customStyles()}
              defaultPageSize={6}
              // pageSizeOptions={[5, 10, 15]}
              onPageChange={this.onPageChange}
              pagination={this.state.paginationValue}
              noDataComponent={<this.CustomNoDataComponent />}

            />)}
        </div>
      </div>
    );
  }
}

export default PatientJournal;



// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/PatientJournal.js